/**
 * Shared Animation Utilities
 *
 * Common utilities used across Letter Throwing animation variants.
 * Extracted for reusability and <300 line file policy compliance.
 */

// Re-export category styles from single source of truth
export { CATEGORY_STYLES, getCategoryFromScore, getCategoryStyle } from '../../../lib/categoryStyles';

// Re-export splitIntoLines from single source of truth (animationHelpers.web.ts)
export { splitIntoLines } from '../animationHelpers.web';
